import CommentsSidebar from './CommentsSidebar';

export default CommentsSidebar;
